// Used in resource.component, assignments-list.component, tiles-resources.component, tiles.component, global-resources.component,
// lesson-view.component, home-page-container.component, page-header.component, filter-menu.component

import { Injectable } from "@angular/core";
import { Router } from "@angular/router";

@Injectable()
export class RouteNamesHelper {
    RESOURCES_PATH_NAME = "resources";
    RESOURCE_PATH_NAME = "resource";
    ASSIGNMENTS_PATH_NAME = "assignments";
    ASSIGNMENT_PATH_NAME = "assignment";
    LESSON_ASSIGNMENT_PATH_NAME = "lesson-assignment";
    LESSON_ACTIVITY_PATH_NAME = "lesson-activity";
    MESSAGES_PATH_NAME = "messages";
    RESOURCES_PERFORM_PATH_NAME = "resources/perform";

    constructor(private router: Router) {}

    public getRouteName(page: string) {
        switch (page) {
            case this.RESOURCES_PATH_NAME:
                return true;
            case this.ASSIGNMENTS_PATH_NAME:
                return true;
            case this.MESSAGES_PATH_NAME:
                return true;
            default:
                return false;
        }
    }

    public getRoutePath(
        routeName: string,
        courseID: number | undefined | null,
        assignmentID: number | undefined | null,
        activityID: number | undefined | null,
        spineID: string | null,
        languageName: string | null,
        exploreID: string | null,
        editionId: string | null,
        isPerform?: boolean |null
    ) {
        if (courseID) {
            let root = "";
            const isTeacher = this.router.url.includes("teacher");
            const isStudent = this.router.url.includes("student");
            if (isStudent) {
                root = "/student";
            }
            if (isTeacher) {
                root = "/teacher";
            }
            switch (routeName) {
                case this.RESOURCES_PATH_NAME:
                    return root + "/resources/courses/" + courseID;
                case this.RESOURCE_PATH_NAME:
                    return (
                        root +
                        "/resources/courses/" +
                        courseID +
                        "/" +
                        editionId +
                        "/resource/" +
                        spineID
                    );
                case this.ASSIGNMENTS_PATH_NAME:
                    return root + "/courses/" + courseID + "/assignments";
                case this.ASSIGNMENT_PATH_NAME:
                    return (
                        root +
                        "/courses/" +
                        courseID +
                        "/assignments/" +
                        assignmentID
                    );
                case this.LESSON_ASSIGNMENT_PATH_NAME:
                    return (
                        root +
                        "/courses/" +
                        courseID +
                        "/assignments/lesson/" +
                        assignmentID
                    );
                case this.LESSON_ACTIVITY_PATH_NAME:
                    return (
                        root +
                        "/courses/" +
                        courseID +
                        "/assignments/lesson/" +
                        assignmentID +
                        "/activity/" +
                        activityID
                    );
                case this.MESSAGES_PATH_NAME:
                    return root + "/messages/inbox";
                case this.RESOURCES_PERFORM_PATH_NAME:
                    if (isTeacher) {
                        return root + "/resources/perform/teacher";
                    } else if (isStudent) {
                        return root + "/resources/perform/student/course/" + courseID;
                    }
                default:
                    return "/student";
            }
        }
    }
}
